import React, { Component } from "react"
import PropTypes from "prop-types"

class PowerBI extends Component {
  constructor(props) {
    super(props)
    this.state = {
      ...props,
      error: {},
    }
  }

  getValue = () => {
    let props = { ...this.state }

    delete props.error
    return {
      type: "powerbi-component",
      props,
    }
  }

  validate = () => {
    for (const key in this.state) {
      if (!this.state[key] && key !== "error") {
        return false
      }
    }

    return true
  }

  handleInputChange(e) {
    this.setState({
      [e.target.name]: e.target.value,
      error: {
        [e.target.name]: !e.target.value ? "invalid" : null,
      },
    })
  }

  render() {
    return (
      <div style={{ padding: "10px" }}>
        <div className="form-group">
          <div className="form-group">
            <label>BI Title</label>
            <input
              onChange={(e) => this.handleInputChange(e)}
              value={this.state.modelTitle}
              name="modelTitle"
              className="form-control"
              aria-describedby="emailHelp"
              placeholder="Power BI post title."
            />
            {this.state.error.modelTitle && (
              <div
                style={{ color: "red" }}
              >{`The Power BI Model Title is ${this.state.error.modelTitle}`}</div>
            )}
          </div>
          <div className="form-group">
            <label>BI Description</label>
            <input
              onChange={(e) => this.handleInputChange(e)}
              value={this.state.modelDescription}
              name="modelDescription"
              className="form-control"
              aria-describedby="emailHelp"
              placeholder="Power BI post description."
            />
            {this.state.error.modelDescription && (
              <div
                style={{ color: "red" }}
              >{`The Power BI Model Description is ${this.state.error.modelDescription}`}</div>
            )}
          </div>
          <label>Workspace ID</label>
          <input
            onChange={(e) => this.handleInputChange(e)}
            value={this.state.workspaceID}
            name="workspaceID"
            className="form-control"
            aria-describedby="emailHelp"
            placeholder="Power BI workspace ID."
          />
          {this.state.error.workspaceID && (
            <div
              style={{ color: "red" }}
            >{`The Power BI Workspace ID is ${this.state.error.workspaceID}`}</div>
          )}
        </div>
        <div className="form-group">
          <label>Report ID</label>
          <input
            onChange={(e) => this.handleInputChange(e)}
            value={this.state.reportID}
            name="reportID"
            className="form-control"
            aria-describedby="emailHelp"
            placeholder="Power BI report ID."
          />
          {this.state.error.reportID && (
            <div
              style={{ color: "red" }}
            >{`The Power BI Report ID is ${this.state.error.reportID}`}</div>
          )}
        </div>
      </div>
    )
  }
}

PowerBI.propTypes = {
  workspaceID: PropTypes.string,
  reportID: PropTypes.string,
  modelTitle: PropTypes.string,
  modelDescription: PropTypes.string,
}

PowerBI.defaultProps = {
  workspaceID: "",
  reportID: "",
  modelTitle: "",
  modelDescription: "",
}

export default PowerBI
